import { toast } from "sonner";
import api from "../lib/api";
import TrackRow from "./TrackRow";
import { meanScore, projectMeta } from "./ProjectGrid";

export default function ProjectView({ project, tracks, onBack, onRowClick, onDeleted }) {
  const score = meanScore(tracks);

  const onDelete = async () => {
    if (!window.confirm(`Delete "${project.title}"? Its tracks stay in your library.`)) return;
    try {
      await api.delete(`/projects/${project.id}`);
      toast.success("Project deleted — tracks kept");
      onDeleted?.(project);
    } catch {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="page-enter" data-testid="project-view">
      <button className="btn btn-ghost" onClick={onBack} style={{ marginBottom: 18, paddingLeft: 0 }} data-testid="project-back-btn">
        ← All projects
      </button>
      <div className="project-hero">
        <div className="project-hero-cover project-cover" style={{ background: project.cover_art_url ? `url("${project.cover_art_url}") center/cover` : undefined }} data-testid="project-hero-cover">
          {!project.cover_art_url && <span className="serif">{(project.title || "?").slice(0, 1)}</span>}
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="eyebrow" style={{ color: "var(--accent)" }}>— {projectMeta(project)}</div>
          <h2 className="serif" style={{ fontSize: 40, lineHeight: 1, margin: "10px 0 8px" }} data-testid="project-view-title">{project.title}</h2>
          {project.primary_artist && <div style={{ color: "var(--text-mute)", marginBottom: 14 }}>{project.primary_artist}</div>}
          <div className="data-line" data-testid="project-view-meta">
            {project.release_date && <>{project.release_date} · </>}
            {tracks.length} track{tracks.length === 1 ? "" : "s"} · {score}% complete
            {project.catalog_number && <> · {project.catalog_number}</>}
          </div>
          <button className="connection-btn danger" style={{ marginTop: 16 }} onClick={onDelete} data-testid="project-delete-btn">
            Delete project
          </button>
        </div>
      </div>
      <div data-testid="project-tracks-list">
        {tracks.length === 0 && <div className="callout" style={{ textAlign: "center", padding: 30 }}>No tracks in this project yet. Open a track and pick this project in its editor.</div>}
        {tracks.map((t, i) => (
          <TrackRow key={t.id} t={t} index={i} coverFallback={project.cover_art_url} onClick={onRowClick} />
        ))}
      </div>
    </div>
  );
}
